import { render, staticRenderFns } from "./DesignationDropdown.vue?vue&type=template&id=ece060b4&"
import script from "./DesignationDropdown.vue?vue&type=script&lang=js&"
export * from "./DesignationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports